/**
 * 传感器配置管理
 */
import React, { useState } from 'react';
import { Card, Form, Row, Col, Button, Input } from 'antd';
import { sensorConfigListRequest } from '@/service/sensorConfigManage';
import { useTable } from '@/utils/useTable';
import { operateTimeRange } from '@/utils/operateSearchParams';
import { sensorSchemeCommonColumns } from '@/columns/sensorScheme';
import CommonTable from '@/components/commonTable';
import RenderEllipsisColumn from '@/components/renderEllipsisColumn';
import PermissionButton from '@/components/permissionButton';
import ExportButton from '@/components/exportButton';
import SensorCommonSearch from '@/components/sensorCommonSearch';
import { formSearchGutter } from '@/constants/common';
import OperateModal from './components/operateModal';
import styles from '@/styles/pageContent.module.scss';

const SensorConfigManage = () => {
  const [form] = Form.useForm();
  const [operateInfo, setOperateInfo] = useState<any>({}); // 操作相关的信息
  const [searchParams, setSearchParams] = useState({}); // 搜索相关的参数
  const { page, limit, loading, data, totalCount, onPageChange, getData } =
    useTable({
      requestFunc: sensorConfigListRequest,
      searchParams
    });

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateTimeRange(values, true);
    setSearchParams(newSearchParams);
  };

  // 表格列显示
  const columns = [
    {
      title: '方案ID',
      dataIndex: 'id',
      width: 70,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '方案名称',
      dataIndex: 'name',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    ...sensorSchemeCommonColumns,
    {
      title: '备注',
      dataIndex: 'ps',
      width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '操作',
      dataIndex: 'operate',
      width: 160,
      fixed: 'right' as const,
      render: (value: any, item: any) => {
        const { id } = item;
        return (
          <div className={styles.tableOperateColumn}>
            <PermissionButton
              operateType="/car-admin/sensorConfig-manage/edit"
              type="link"
              onClick={() => setOperateInfo({ type: 'edit', data: item })}
            >
              编辑
            </PermissionButton>
            <PermissionButton
              operateType="/car-admin/sensorConfig-manage/saveAs"
              type="link"
              onClick={() => setOperateInfo({ type: 'saveAs', data: item })}
            >
              另存
            </PermissionButton>
            <ExportButton
              type="link"
              requestMethod="GET"
              url={`api/v2/program/downloadHex/${id}`}
              fileName={`${item.name}`}
              fileSuffix="hex"
              getParamsFunc={() => ({})}
              permissionKey="/car-admin/sensorConfig-manage/download"
            >
              下载
            </ExportButton>
          </div>
        );
      }
    }
  ];

  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Form onFinish={onSearch} form={form} autoComplete="off">
        <Row gutter={formSearchGutter}>
          <Col span={8}>
            <Form.Item label="项目名称" name="projectName">
              <Input placeholder="请输入项目名称" allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="方案名称" name="name">
              <Input placeholder="请输入方案名称" allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="方案编号" name="id">
              <Input placeholder="请输入方案编号" allowClear />
            </Form.Item>
          </Col>
          <SensorCommonSearch span={8} />
          <Col span={6}>
            <Form.Item>
              <div className={styles.searchBox}>
                <Button type="primary" htmlType="submit">
                  搜索
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.operateBox}>
        <PermissionButton
          operateType="/car-admin/sensorConfig-manage/add"
          type="primary"
          onClick={() => setOperateInfo({ type: 'add' })}
        >
          创建新方案
        </PermissionButton>
      </div>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
      />
      {['add', 'edit', 'saveAs'].includes(operateInfo.type) && (
        <OperateModal
          type={operateInfo.type}
          data={operateInfo.data}
          closeModal={() => setOperateInfo({})}
          reloadData={getData}
        />
      )}
    </Card>
  );
};

export default SensorConfigManage;
